import { CamelCase } from '../../helpers/typeHelpers';

export enum AccountType {
  Free = 'free',
  Subscribed = 'subscribed',
  Payg = 'PAYG',
}
export interface AppResponse {
  id: string;
  apikey: string;
  name: string;
}

export interface UserInfoResponse {
  api_settings: {
    custom_limit: number | null;
    is_trial: boolean;
    status: AccountType;
  };
}

export interface UserInfo {
  apiSettings: {
    customLimit: number | null;
    isTrial: boolean;
    status: AccountType;
  };
}

export type AppsResponse = AppResponse[];

export interface UsageLimitResponse {
  limit: number;
  used: number;
  request_type: string;
}

export type UsageLimit = CamelCase<UsageLimitResponse>;

export interface AccountLimitsResponse {
  limits: UsageLimitResponse[];
  top_up: TopUpResponse;
}

export type AccountLimits = {
  limits: UsageLimit[];
  topUp: TopUp;
};
export interface TopUpResponse {
  total: number;
  used: number;
}

export type TopUp = CamelCase<TopUpResponse>;

export interface PurchaseHistoryItemResponse {
  id: string;
  created_at: string;
  product_name: string;
  total: number;
  used: number;
  amount_cents: number;
}

export type PurchaseHistoryResponse = PurchaseHistoryItemResponse[];

export type PurchaseHistoryItem = CamelCase<PurchaseHistoryItemResponse>;
export type PurchaseHistory = PurchaseHistoryItem[];

export interface AccountCreditsResponse {
  id: string;
  created_at: string;
  payg_credits: number;
  subscription_credits: number;
  subscription_credits_total: number;
  subscription_period_start: string | null;
}

export interface AccountCredits {
  id: string;
  createdAt: string;
  paygCredits: number;
  subscriptionCredits: number;
  subscriptionCreditsTotal: number;
  subscriptionPeriodStart: string | null;
}
